enum PageSelectionElementIdEnum {
  AccessListingPages = "accessListing",
  AccessOverviewPages = "accessOverview",
  AccessRadiusSearchPages = "accessRadiusSearch",
  AccessReportsWizardSummaryPages = "accessSummary",
  AccessReportsWizardDetailsPages = "accessDetail",
  EmployeeCountPages = "employeeCount",
  ProviderCountPages = "providerCount",
}

export { PageSelectionElementIdEnum };
